import LogRocket from "logrocket";

if (window.location.hostname !== "localhost") {
  LogRocket.init("e5ud8k/wildmavins", {
    release: process.env.VERCEL_GIT_COMMIT_SHA || "unknown",
  });
}
